<template>
  <span>
    <div
      v-if="data.length"
      class="pt-1"
    >
      <p class="text-center text-primary">
        Monthly Application Trend
      </p>
      <apexchart
        type="area"
        height="350"
        :options="chartOptions"
        :series="seriesData"
      />
    </div>
    <div v-else>
      <p class="py-2 text-center text-primary">
        No data yet!
      </p>
    </div>
  </span>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    categoriesData() {
      return this.data.map(item => item.month)
    },
    seriesData() {
      return [{ data: this.data.map(item => item.total), name: 'Applications' }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'area',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: ['#28c76f'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        xaxis: {
          categories: this.categoriesData,
        },
        tooltip: {
          theme: 'dark',
        },
      }
    },
  },
}
</script>
